var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 354,
    height: 136,
    viewBox: "0 0 354 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.2682 16.2639H88.8894C94.8263 16.2639 102.34 17.6834 102.34 27.7809C102.34 37.8795 91.5958 41.9966 83.6267 41.9966H67.2682V16.2639ZM67.2682 55.7186H79.5871C99.8323 55.7186 110.15 60.1497 110.15 72.0168C110.15 82.5351 101.873 86.9818 88.8933 86.9818H69.1816L46.64 102.792V102.794L88.7394 102.784C113.951 102.784 130.925 93.6914 130.925 72.6514C130.925 54.299 115.902 47.0913 102.496 47.0913C111.761 47.0913 122.708 38.7751 122.708 24.673C122.708 10.5736 109.834 0.449951 95.1564 0.449951L52.1857 0.451064H42.8672L46.64 8.83176V95.4299L67.2682 80.9592V55.7186Z",
    fill: "#22409A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.756 16.2628H178.807C184.605 16.2628 214.17 17.7318 214.17 51.6214C214.17 90.2895 178.807 86.9734 178.807 86.9734L166.674 86.9785L144.126 102.79V102.793H184.605C209.815 102.793 235.663 87.2612 235.663 51.6214C235.663 20.0231 213.093 0.449951 184.605 0.449951H140.355L144.126 8.83065V95.4248L164.756 80.9581V16.2628Z",
    fill: "#22409A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.597 51.6477C266.597 22.7097 286.501 14.5795 299.396 14.5795C312.289 14.5795 332.193 22.7097 332.193 51.6477C332.193 80.588 312.289 88.7159 299.396 88.7159C286.501 88.7159 266.597 80.588 266.597 51.6477ZM245.104 51.6477C245.104 92.4807 278.048 103.951 299.396 103.951C320.738 103.951 353.686 92.4807 353.686 51.6477C353.686 10.8158 320.738 -0.655518 299.396 -0.655518C278.048 -0.655518 245.104 10.8158 245.104 51.6477Z",
    fill: "#22409A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.449951V128.027L20.1502 113.891V0.449951H0Z",
    fill: "#ED1A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8302 119.276L-0.0928633 136.052L352.498 135.956L352.503 119.187L23.8302 119.276Z",
    fill: "#ED1A3B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 354,
    height: 136,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.609c9eb07a9776d1e5465818fbc60701.svg";
export { ForwardRef as ReactComponent };